import K_PopUpWorkspaceWrapper from "../templates/K_PopUpWorkspaceWrapper";
import { Component, ComponentOptions } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface PopUpWorkspaceWrapperOptions extends ComponentOptions {
    components: Component[];
    bsc?: string;
    style?: string;
}

export class PopUpWorkspaceWrapper extends TemplateComponent {

    options: PopUpWorkspaceWrapperOptions;
    content: {
        components: Component[];
    };

    constructor(options: PopUpWorkspaceWrapperOptions) {
        super(K_PopUpWorkspaceWrapper, options);

        this.content = {
            components: options.components
        };
    }

    create() {
        var elem = $("#" + this.options.id);
        var popUpWidth = elem.parents(".k-window").width();

        elem.width(popUpWidth - 18); // 18 for padding
    }

}
